export default __webpack_public_path__ + "static/subscribe-desktop-f48a8aaa9486cd1c3a46d90c984fdfa9.png";